export default __webpack_public_path__ + "static/media/raum-utrecht.9447a020.jpg";